import { GUARD_EXEMPT_PREFIXES } from "@/settings/constant";
// 학생/학부모 여부 — 이들은 학교+학년을 한 화면(studentSchool)에서 설정하고 `schoolGrade`로 완료를 판정한다.
const isStudentOrParent = (job)=>job === "student" || job === "parent";
/**
 * User Entity의 필수 프로필값을 순차 검사해 이동해야 할 설정 단계를 반환한다.
 * 모두 충족하면 null(프로필 완료).
 *
 * 판정 순서 (PRD #프로필 설정 미완료 진입 처리):
 *   1) job 없음                                 → 'userType'
 *   2) mainSubject 없음 (단 university는 면제)   → 'subject'
 *   3) job이 학생/학부모: grade 없음             → 'studentSchool'  (schools가 있어도 grade 없으면 재진입)
 *      그 외(선생님/학원장/대학생): schools 없음  → 'school'
 *   4) 모두 충족                                 → null
 *
 * 학생/학부모는 학교+학년이 한 화면이라 grade 유무가 곧 완료 판정이다(학년은 학교 선택 후에만 고를 수 있으므로
 * grade가 있으면 school도 반드시 존재). 따라서 grade와 school은 job 타입에 따라 상호 배타적으로 검사된다.
 */ export const resolveProfileStep = (user)=>{
    var _user_schoolItems;
    if (!(user === null || user === void 0 ? void 0 : user.job)) return "userType";
    if (!user.mainSubject && user.job !== "university") return "subject";
    if (isStudentOrParent(user.job)) {
        if (!user.schoolGrade) return "studentSchool";
    } else if (!((_user_schoolItems = user.schoolItems) === null || _user_schoolItems === void 0 ? void 0 : _user_schoolItems.length)) {
        return "school";
    }
    return null;
};
// 프로필 가드 면제 경로 여부. 설정/인증 플로우(목적지) 및 별도 도메인은 가드하지 않는다.
export const isGuardExemptPath = (pathname)=>GUARD_EXEMPT_PREFIXES.some((prefix)=>pathname === prefix || pathname.startsWith("".concat(prefix, "/")));
